import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const cwibSwiperInstances = [];
const breakpoint = window.matchMedia('(min-width: 992px)');

document.addEventListener('DOMContentLoaded', () => {
    const cwibCardSliders = document.querySelectorAll('.full-width-multi-image-section .fwmi-card-slider');

    // Initial load
    initializeFullWidthCards();
    handleBreakpointChange(cwibCardSliders, cwibSwiperInstances, enableCwibCardSliders);

    // On resize/breakpoint change
    breakpoint.addEventListener('change', () => {
        handleBreakpointChange(cwibCardSliders, cwibSwiperInstances, enableCwibCardSliders);
    });

    window.addEventListener('resize', () => {
        initializeFullWidthCards();
    });
});

function updateFullWidthCardHeights() {
    if (window.innerWidth >= 991) {
        const items = document.querySelectorAll('.full-width-multi-image-section .fwmi-item');
        items.forEach(item => {
            const contentWrap = item.querySelector('.fwmi-content-mainwrap');
            const contentHeight = contentWrap ? contentWrap.offsetHeight + 'px' : '-20px';
            const headingWrap = item.querySelector('.fwmi-heading-wrap');
            if (headingWrap) {
                headingWrap.style.setProperty('--contentHeight', contentHeight);
            }
        });
    }
}

function initializeFullWidthCards() {
    if (window.innerWidth >= 991) {
        const cwibSections = document.querySelectorAll('.full-width-multi-image-section');
        cwibSections.forEach(section => {
            const iconButtons = section.querySelectorAll('.fwmi-item .fwmi-item-inner');
            iconButtons.forEach(icon => {
                icon.addEventListener('click', event => {
                    const parentItem = icon.closest('.fwmi-item');
                    if (parentItem) {
                        const siblings = parentItem.parentElement.querySelectorAll('.fwmi-item');
                        siblings.forEach(sibling => sibling.classList.remove('is-active'));
                        parentItem.classList.add('is-active');
                    }
                });
            });
            setTimeout(() => {
                updateFullWidthCardHeights();
            }, 550);
        });
    }
}

function enableCwibCardSliders(sliderElements, instanceArray) {
    sliderElements.forEach(slider => {
        const swiperInstance = new Swiper(slider, {
            spaceBetween: 30,
            slidesPerView: 1,
            loop: false,
            autoHeight: true,
            pagination: {
                el: slider.parentNode.querySelector('.fwmi-pagination'),
                clickable: true,
            },
        });
        instanceArray.push(swiperInstance);
    });
}

function destroySliders(sliderInstances) {
    if (!Array.isArray(sliderInstances)) {
        return;
    }

    sliderInstances.forEach(instance => {
        if (instance && typeof instance.destroy === 'function') {
            instance.destroy(true, true);
        }
    });
    sliderInstances.length = 0; // Clear the array without reassigning
}

function handleBreakpointChange($sliders, sliderInstances, enableSlider) {
    if (window.matchMedia('(min-width: 992px)').matches) {
        destroySliders(sliderInstances);
    } else {
        enableSlider($sliders, sliderInstances);
    }
}
